import { Box, Paper, Stack, Tab, Tabs } from '@mui/material'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DeliveryMemoFilter from './DeliveryMemoFilter'
import DeliveryMemoTable from './DeliveryMemoTable'
import { DeliveryMemoBottom1, DeliveryMemoBottom2 } from './DeliveryMemoBottom'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { styled } from '@mui/system'
import { tabLabels, transparentStyle, getTransferData, transformData, pancardValidation, ValidateAadhaar, DownloadDeliveredTicketPdfs } from './const'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import PrintIcon from '@mui/icons-material/Print'
import PrintShortIcon from '@mui/icons-material/PrintOutlined'
import PdfIcon from '@mui/icons-material/PictureAsPdf'
import { useTheme } from '@mui/material/styles'
import ExcelIcon from '@mui/icons-material/FileCopy'
import moment from 'moment'
import { GetMOFPaymentUpdate, getDeliveryMemo, getDriverList, getIDProofList, getLrDetailsWIthBookingID, getVehicleList, updateAlertError, updateLoader } from '../../../store/common/common_action'
import DeliveryMemoTableTwo from './DeliveryMemoTableTwo'
import DeliveryMemoTableThree from './DeliveryMemoTableThree'
import { useState } from 'react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { SuccessPopUp } from '../../common/snippets'
import { Grid } from '@mui/material'
import { headerColumnDefs, columnStylesThree, columnDefsThreeA, columnDefsTwoA, columnDefsForExeFormat, exeColumnStyles } from './DeliveryMemoTableDefs'
import { dynamicTableStyles, columnStylesTwo, columnStylesOne, columnDefsOneA } from './DeliveryMemoTableDefs'
import { callApiForArray, GetRequest } from '../../common/api'
import { urls } from '../../common/constants'
import * as error from '../../common/error_strings'
import { clickElement, filterData, focusElemnt, getDeliveryGst1, isEmpty, navigation1, navigation3 } from '../../common/helper'
import { BookingConfirm } from '../../common/bookingConfirm'
import DeliveryMemoTblPdf from './DeliveryMemoTblPdf'
import { callAddFontRobotoBold } from '../../common/font/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/font/Roboto-Medium-normal'
import { useAtom } from 'jotai'
import { destinationCityAtom, destinationCityListAtom, sourceCityAtom, sourceCityListAtom } from '../../common/jotaiState/deliverymemoStateAtoms'
import { alertAtom, modalAtom } from '../../common/jotaiState/globalStateAtoms'
import LoaderModel from './loaderModel'
import { SAINI_TRAVELS, SAMAY_TRAVEL, TULSI_TRAVEL, HANS_COMPANY_ID } from '../../../helper/companyIdhardcode'
const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: 4,
    backgroundColor: theme.palette.primary.main,
  },
}))
const DeliveryMemo = (props) => {
  const { data, getVehicleList, getIDProofList, GetMOFPaymentUpdate, updateAlertError, updateLoader } = props
  const { common } = data
  const { loginData, deliveryMemoList, brnchList, driverInfo, vehicleList, companySettings: companySettingsL, gstConfig } = common
  const companySettings = companySettingsL?.[0] || {}
  const { intCompanyID, intBranchID } = loginData
  const { HasGSTOnDelivery = false, HasContactNoCompulsory = false } = companySettings
  const { DefaultCurrencyID } = companySettings
  const isCompanyTwelve = intCompanyID === SAINI_TRAVELS
  const hiddenCompanyTwelveDeliveryCols = ['AdditionalDeliveryCartage', 'DeliveryChg', 'ExtraHamli', 'DemurrageChg', 'Discount', 'DeliveryGST']
  const senderColumnDefOneA = { headerName: 'Sender Name\nSender No.', exportHead: 'Sender Name\nSender No.', field: 'sendSender', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } }
  const columnStylesOneCompanyTwelve = { ...columnStylesOne, 7: { halign: 'left', font: 'Roboto', fontSize: 16 } }
  const getCompanyColumnDefsOneA = () => {
    if (!isCompanyTwelve) return columnDefsOneA
    const columnDefsWithSender = [...columnDefsOneA.slice(0, 5), senderColumnDefOneA, ...columnDefsOneA.slice(5)]
    return columnDefsWithSender.filter((col) => !hiddenCompanyTwelveDeliveryCols.includes(col.field))
  }
  const { getIdProof, methodOfPayment, partyList, lrDetailsData } = common
  const { getDeliveryMemo, getDriverList, getLrDetailsWIthBookingID } = props
  const theme = useTheme()
  const [selectedTab, setSelectedTab] = useState(0)
  const [isExpanded, setIsExpanded] = useState(false)
  const [memoFromDate, setMemoFromDate] = useState(moment(new Date()))
  const [memoToDate, setMemoToDate] = useState(moment(new Date()))
  const [isShowAllLRs, setIsShowAllLRs] = useState(0)
  const [tableData, setTableData] = useState([])
  const [isPdfLoaded, setIsPdfLoaded] = useState(false)
  const [excelData, setexcelData] = useState([])
  const [sourceCity, setSourceCity] = useAtom(sourceCityAtom)
  const [destinationCity, setDestinationCity] = useAtom(destinationCityAtom)
  const [, setSourceCityListData] = useAtom(sourceCityListAtom)
  const [, setDestinationCityListData] = useAtom(destinationCityListAtom)
  const [MOPList, setMOPList] = useState([])
  const filters = {
    PaymentType: '',
    ChallanNo: '',
    LRNO: '',
    ManualLRNo: '',
    Sender: '',
    SenderMobileNo: '',
    SenderGSTN: '',
    SenderEmailID: '',
    RecName: '',
    RecMobileNo: '',
    ReceiverEmailID: '',
    ReceiverGSTN: '',
    PinCode: '',
  }
  const [moreFilter, setMoreFilter] = useState(filters)
  const [appliedMoreFilter, setAppliedMoreFilter] = useState({})
  const [filterheight, setFilterHeight] = useState(0)
  const [bulkDeliveryCheck, setBulkDeliveryCheck] = useState(false)
  const [reciverName, setRecieverName] = useState('')
  const [reciverPhone, setReceiverPhone] = useState('')
  const [selectedRecIdType, setselectedRecIdType] = useState(null)
  const [ReIdNumber, setReIdNumber] = useState('')
  const [selectedMOP, setSelectedMOP] = useState('')
  const [selectedParty, setSelectedParty] = useState(null)
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const [remarks, setRemarks] = useState('')
  const [selectedLrs, setSelectedLrs] = useState([])

  const dynamicFilterNames = {
    PaymentType: 'Payment Type',
    ChallanNo: 'Challan No.',
    LRNO: 'LR No.',
    ManualLRNo: 'Offline LR No.',
    Sender: 'Sender',
    SenderMobileNo: 'Sender No',
    SenderGSTN: 'Sender GSTIN',
    SenderEmailID: 'Sender Email ID',
    RecName: 'Receiver',
    RecMobileNo: 'Receiver No',
    ReceiverEmailID: 'Receiver Email ID',
    ReceiverGSTN: 'Receiver GSTIN',
    PinCode: 'Pincode',
  }
  //tab two data
  const [brnchForDelivery, setBrnchForDelivery] = useState('')
  const [trnsfrVehicle, setTrnsfrVehicle] = useState('')
  const [driverName, setDriverName] = useState('')
  const [remark, setRemark] = useState('')
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showConfirmationTwo, setShowConfirmationTwo] = useState(false)
  const [showLRDetails, setShowLRDetails] = useState(false)
  const [clickBookingId, setClickedBookingID] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [tillDate, setTillDate] = useState(false)
  const [showAll, setShowAll] = useState(false)
  const [resetFilter, setResetFilter] = useState(false);
  const [resetMainFilter, setResetMainFilter] = useState(false);
  const [checkboxStates, setCheckboxStates] = useState({});
  //more filter
  const [paymentTypeListData, setPaymentListData] = useState([])
  const [challanNoListData, setChallanNoListData] = useState([])
  const [lrNoListData, setLrNoListData] = useState([])
  const [offlineLrNoListData, setOfflineLrNoListData] = useState([])
  const [senderListData, setSenderListData] = useState([])
  const [senderMobileNoListData, setSenderMobileNoListData] = useState([])
  const [senderGSTNListData, setSenderGSTNListData] = useState([])
  const [senderEmailIDListData, setSenderEmailIDListData] = useState([])
  const [recNameListData, setRecNameListData] = useState([])
  const [recMobileNoListData, setRecMobileNoListData] = useState([])
  const [receiverEmailIDListData, setReceiverEmailIDListData] = useState([])
  const [receiverGSTNListData, setReceiverGSTNListData] = useState([])
  const [pinCodeListData, setPinCodeListData] = useState([])
  const [modal, setModal] = useAtom(modalAtom)
  const [, setAlert] = useAtom(alertAtom)
  const [cityListData, setCityListData] = useState([])
  const [deliveryMemoData, setDeliveryMemoData] = useState([])
  const showSuccessAndReload = (msg) => {
    setAlert({
      show: true,
      msg,
      success: true,
      close: () => {
        setAlert({ show: false, msg: '' })
        reloadTable()
      },
    })
  }

  let dynamicHeaderDefs = [
    { header: 'Source City', dataKey: 'sourceCity', xlCol: { dataType: 'string', dataFormatter: null } },
    { header: 'Destination City', dataKey: 'destinationCity', xlCol: { dataType: 'string', dataFormatter: null } },
  ]
  const memoFilterData = {
    isExpanded, memoToDate, memoFromDate, moreFilter, appliedMoreFilter, showMore, tillDate, showAll, resetFilter, resetMainFilter,
    paymentTypeListData, challanNoListData, lrNoListData, offlineLrNoListData, senderListData, senderMobileNoListData, senderMobileNoListData, senderGSTNListData, senderGSTNListData, senderEmailIDListData, recNameListData,
    recMobileNoListData, receiverEmailIDListData, receiverGSTNListData, pinCodeListData
  }
  const memoFilterMethods = {
    setMemoFromDate, setMemoToDate, setMoreFilter, setAppliedMoreFilter, setShowMore, setTillDate, setShowAll, setResetFilter, setPaymentListData, setChallanNoListData, setLrNoListData, setIsPdfLoaded,
    setOfflineLrNoListData, setSenderListData, setSenderMobileNoListData, setSenderGSTNListData, setSenderEmailIDListData, setRecNameListData, setRecMobileNoListData, setReceiverEmailIDListData, setReceiverGSTNListData, setPinCodeListData, setIsExpanded
  }
  const bulkDeliverMsg = selectedLrs.length === 1 ? 'LR Delivered Successfully' : 'All LRs Delivered Successfully!'
  const bulkDeliver = () => {
    const commonData = {
      ReceivedBy: reciverName || '',
      RecMobileNo: reciverPhone || '',
      SenderIDProofID: selectedRecIdType?.IDProofid || 0,
      IDProof: ReIdNumber || '',
      PaymentType: selectedMOP?.ModeID || 0,
      ReceivingPartyID: selectedParty?.PartyID || 0,
      VehicleNo: selectedVehicle?.VehicleNo || '',
      Remarks: remarks,
      intUserID: loginData.intUserID,
    }
    const dataArray = transformData(selectedLrs, commonData, loginData)
    updateLoader(true)
    callApiForArray(urls.deliveryWebInsert, dataArray)
      .then(async (res) => {
        if (loginData?.intCompanyID === HANS_COMPANY_ID) {
          await DownloadDeliveredTicketPdfs(res, selectedLrs, { intBranchID, loginData })
        }
        updateLoader(false)
        showSuccessAndReload(bulkDeliverMsg)
      })
      .catch((err) => {
        updateLoader(false)
        console.log(err)
      })
  }
  const bulkTransferMsg = selectedLrs.length === 1 ? 'LR Transferred Successfully' : 'All LRs Transferred Successfully!'
  const bulkDeliverTwo = () => {
    const commonData = {
      BranchForDelTrans: brnchForDelivery.BranchID || 0,
      VehicleNo: trnsfrVehicle?.VehicleNo || '',
      Remarks: remark,
      driverName: driverName.DriverConductorID || 0,
      toCity: brnchForDelivery.CityID,
      intUserID: loginData.intUserID,
      intCompanyID: loginData.intCompanyID,
    }
    const dataArray = getTransferData(selectedLrs, commonData)
    updateLoader(true)
    callApiForArray(urls.getBranchTransfer, dataArray)
      .then((res) => {
        updateLoader(false)
        if (typeof res === 'object' && res[0][0]?.status === true) {
          showSuccessAndReload(bulkTransferMsg)
        } else {
          updateLoader(false)
          updateAlertError({ show: true, msg: 'LR Transfer Failed!', success: false })
        }
      })
      .catch((err) => {
        updateLoader(false)
        console.log(err)
      })
  }
  const handleIdProofInput = (e) => {
    let idValue = e.target.value;
    if (idValue !== '' && selectedRecIdType.IDProof === 'PAN Card') {
      if (pancardValidation(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: 'Invalid PAN Card Number', nextId: 'memoDeliveryReceiverIdNumber' })
      }
    } else if (idValue !== '' && selectedRecIdType.IDProof === 'Aadhar Card') {
      if (ValidateAadhaar(idValue)) {
        setReIdNumber(idValue)
      } else {
        setReIdNumber('')
        updateAlertError({ show: true, msg: 'Invalid Aadhaar Number', nextId: 'memoDeliveryReceiverIdNumber' })
      }
    } else {
      if (idValue !== '') {
        setReIdNumber(idValue)
      }
    }
  }

  const resetValues = () => {
    setReIdNumber('')
    updateAlertError({ show: false, msg: '' })
    focusElemnt('memoDeliveryReceiverIdNumber')
  }
  useEffect(() => {
    if (sourceCity.length) {
      setCityListData(
        sourceCity.map((val) => ({
          loaded: 0,
          data: [],
          id: val.id,
          name: val.sourceCityList,
        }))
      )
    }
  }, [sourceCity])
  useEffect(() => {
    if (deliveryMemoList?.length !== 0) {
      const newSourceCityListData = deliveryMemoList
        .reduce(
          (acc, item) => {
            if (!acc.seenIds.has(item.SourceCityID)) {
              acc.result.push({
                sourceCityList: item.SourceCity,
                id: item.SourceCityID,
              })
              acc.seenIds.add(item.SourceCityID)
            }
            return acc
          },
          { result: [], seenIds: new Set() }
        )
        .result.sort((a, b) => a.sourceCityList.localeCompare(b.sourceCityList))
      setSourceCityListData(newSourceCityListData)
      setSourceCity([newSourceCityListData[0]])

      const newDestinationCityListData = [...(deliveryMemoList || [])]
        .reduce(
          (acc, item) => {
            if (!acc.seenIds.has(item.DestinationCityID)) {
              acc.result.push({
                DestinationCity: item.DestinationCity,
                DestinationCityID: item.DestinationCityID,
              })
              acc.seenIds.add(item.DestinationCityID)
            }
            return acc
          },
          { result: [], seenIds: new Set() }
        )
        .result.sort((a, b) => a.DestinationCity.localeCompare(b.DestinationCity))
      setDestinationCityListData(newDestinationCityListData)
      setDestinationCity(newDestinationCityListData[0])
    } else {
      setResetMainFilter(!resetMainFilter)
      setSourceCityListData([])
      setDestinationCityListData([])
      setSourceCity([])
      setDestinationCity({})
    }
  }, [deliveryMemoList])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      getVehicleList(loginData)
      getDriverList(loginData)
      getIDProofList(loginData)
      GetMOFPaymentUpdate({ intBranchID: loginData?.intBranchID })
    }
  }, [loginData])
  useEffect(() => {
    if (selectedLrs.length > 1) setBulkDeliveryCheck(true)
    else setBulkDeliveryCheck(false)
  }, [selectedLrs])
  const getFinalAmount = (data, DeliveryGST = 0, Discount = 0) => {
    const baseCharges =
      (+data?.AdditionalDeliveryCartage || 0) +
      (+data?.DeliveryChg || 0) +
      (+data?.ExtraHamli || 0) +
      (+data?.DemurrageChg || 0) +
      (+DeliveryGST || 0) -
      (+Discount || 0)

    if ([2, 4, 7, 9].includes(data?.PaymentTypeID)) {
      return (+data?.TotalDues || 0) + baseCharges
    }
    return baseCharges
  }
  useEffect(() => {
    if (methodOfPayment?.Data?.Table?.length > 0) {
      setMOPList(methodOfPayment?.Data?.Table)
    } else {
      setMOPList([])
    }
  }, [methodOfPayment?.Data?.Table])

  useEffect(() => {
    if (selectedLrs?.length > 0 && selectedTab === 0) {
      switch (selectedLrs?.[0]?.PaymentTypeID) {
        case 1:
        case 6:
        case 8:
        case 9:
          let newList = methodOfPayment?.Data?.Table?.filter((item) => item?.ModeID !== 2)
          setMOPList(newList)
          setSelectedMOP(methodOfPayment?.Data?.Table?.find((item) => item?.ModeID === 1))
          //set selectedMOP to cash
          //remove credit option from list
          break;
        case 2:
        case 4:
        case 7:
          setMOPList(methodOfPayment?.Data?.Table)
          setSelectedMOP(methodOfPayment?.Data?.Table?.find((item) => item?.ModeID === 1))
          //set selectedMOP to cash
          break;
        case 5:
        case 10:
          setMOPList(methodOfPayment?.Data?.Table)
          setSelectedMOP(methodOfPayment?.Data?.Table?.find((item) => item?.ModeID === 2))
          //set selectedMOP to credit and disable
          //set selectedMOP to party disabled 
          break;
        default:
          setMOPList(methodOfPayment?.Data?.Table)
          setSelectedMOP('')
      }
    }

  }, [selectedLrs])

  const getTableInfo = (arr) => {
    return arr.map((item, i) => {
      const am = item.DeliveryChg + item.DemurrageChg
      const DeliveryGST = getDeliveryGst1(intCompanyID, HasGSTOnDelivery, am, 0.18, item.DeliveryGST, gstConfig, item).toFixed(2)
      return {
        ...item,
        srNo: i + 1,
        ReceiptDate: moment(item.ReceiptDate).format('DD-MM-YYYY'),
        brnchForDelivery: '',
        Discount: 0,
        DeliveryGST,
        finalAmount: getFinalAmount(item, DeliveryGST, 0),
      }
    })
  }

  const reloadTable = () => {
    setShowMore(false);
    setResetFilter(false);
    setTimeout(() => {
      setResetFilter(true)
    }, 100);
    setMoreFilter(filters);
    setIsExpanded(false);
    setIsPdfLoaded(false)
    setBrnchForDelivery('');
    setTrnsfrVehicle('')
    setDriverName('')
    setRemark('')
    setRecieverName('')
    setReceiverPhone('')
    setselectedRecIdType(null)
    setReIdNumber('')
    setSelectedMOP('')
    setSelectedParty(null)
    setSelectedVehicle(null)
    setRemarks('')

    setSelectedLrs([])
    setTableData([]);
    setAppliedMoreFilter({});

    setPaymentListData([])
    setChallanNoListData([])
    setLrNoListData([])
    setOfflineLrNoListData([])
    setSenderListData([])
    setSenderMobileNoListData([])
    setSenderGSTNListData([])
    setSenderEmailIDListData([])
    setRecNameListData([])
    setRecMobileNoListData([])
    setReceiverEmailIDListData([])
    setReceiverGSTNListData([])
    setPinCodeListData([])
    handleGenerate()
    setBulkDeliveryCheck(true)
    setTimeout(() => {
      setBulkDeliveryCheck(false)
    }, 100);
    updateAlertError({ show: false, msg: '' })
    focusElemnt('memoGenerate')
  }
  const resetTabData = () => {
    setMemoFromDate(moment(new Date()))
    setMemoToDate(moment(new Date()))
    setTillDate(false)
    setShowAll(false)
    setShowMore(false)
    setIsPdfLoaded(false)
    setSourceCity([])
    setDestinationCity({})
    setSourceCityListData([])
    setDestinationCityListData([])
    setResetFilter(false);
    setTimeout(() => {
      setResetFilter(true)
    }, 100);
    setResetMainFilter(false);
    setTimeout(() => {
      setResetMainFilter(true)
    }, 100);
    setMoreFilter(filters);
    setIsExpanded(false);
    setBrnchForDelivery('');
    setTrnsfrVehicle('')
    setDriverName('')
    setRemark('')
    setRecieverName('')
    setReceiverPhone('')
    setselectedRecIdType(null)
    setReIdNumber('')
    setSelectedMOP('')
    setSelectedParty(null)
    setSelectedVehicle(null)
    setRemarks('')
    setBulkDeliveryCheck(true)
    setTimeout(() => {
      setBulkDeliveryCheck(false)
    }, 100);
    setSelectedLrs([])
    setTableData([]);
    setAppliedMoreFilter({});
    setCheckboxStates({})

    setPaymentListData([])
    setChallanNoListData([])
    setLrNoListData([])
    setOfflineLrNoListData([])
    setSenderListData([])
    setSenderMobileNoListData([])
    setSenderGSTNListData([])
    setSenderEmailIDListData([])
    setRecNameListData([])
    setRecMobileNoListData([])
    setReceiverEmailIDListData([])
    setReceiverGSTNListData([])
    setPinCodeListData([])
    updateAlertError({ show: false, msg: '' })
    setMOPList([])
    setexcelData([])
  }

  const updateSelectedList = (e, data, selectedLrs, setSelectedLrs) => {
    if (e.target.checked) {
      setSelectedLrs([...selectedLrs, data])
      setCheckboxStates({ ...checkboxStates, [data.BookingID]: true });
      // if (selectedLrs?.length === 0 || selectedLrs?.[0]?.PaymentTypeID === data?.PaymentTypeID) {
      //   setSelectedLrs([...selectedLrs, data])
      //   setCheckboxStates({ ...checkboxStates, [data.BookingID]: true });
      // } else {
      //   updateAlertError({ show: true, msg: 'Please Select LR With Same Payment Type', nextId: '' })
      //   setCheckboxStates({ ...checkboxStates, [data.BookingID]: false });
      // }
    }
    else {
      if (selectedLrs.length === 1) {
        if (selectedTab === 0) {
          setRecieverName('')
          setReceiverPhone('')
          setselectedRecIdType(' ')
          setReIdNumber('')
          setSelectedMOP('')
          setSelectedParty(null)
          setSelectedVehicle(null)
          setRemarks('')
          setSelectedLrs([])
          setCheckboxStates({})
        } else {
          setBrnchForDelivery('')
          setTrnsfrVehicle('')
          setDriverName('')
          setRemark('')
          setSelectedLrs([])
        }
        setCheckboxStates({ ...checkboxStates, [data.BookingID]: false });
      } else {
        setSelectedLrs(selectedLrs.filter((obj) => obj.BookingID !== data.BookingID))
        setCheckboxStates({ ...checkboxStates, [data.BookingID]: false });
      }
    }
  }
  const updateSelectedList1 = (e, data, selectedLrs, setSelectedLrs) => {
    if (e.target.checked) {
      setSelectedLrs([...selectedLrs, data])
    }
    else {
      if (selectedLrs.length === 1) {
        if (selectedTab === 0) {
          setRecieverName('')
          setReceiverPhone('')
          setselectedRecIdType(' ')
          setReIdNumber('')
          setSelectedMOP('')
          setSelectedParty(null)
          setSelectedVehicle(null)
          setRemarks('')
          setSelectedLrs([])
        } else {
          setBrnchForDelivery('')
          setTrnsfrVehicle('')
          setDriverName('')
          setRemark('')
          setSelectedLrs([])
        }
      } else {
        setSelectedLrs(selectedLrs.filter((obj) => obj.BookingID !== data.BookingID))
      }
    }
  }
  const handleTabChange = (event, newValue) => {
    resetTabData()
    setSelectedTab(newValue)
    setIsExpanded(false)
  }
  const handleGenerate = async () => {
    const object = {
      CompanyId: loginData.intCompanyID,
      BranchId: loginData.intBranchID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      DestinationCityID: destinationCity.DestinationCityID,
      UserId: loginData.intUserID,
      Mode: selectedTab + 1,
      IsShowAllLRs: isShowAllLRs,
      IsDelivered: 0,
    }
    const payloadList = sourceCity.map((item) => ({ ...object, SourceCityID: item.id }))
    setModal('loaderModal')
    const memoDataList = []
    for (let i = 0; i < sourceCity.length; i++) {
      const id = sourceCity[i].id
      setCityListData((prevList) => prevList.map((item) => (item.id === id ? { ...item, loaded: 1 } : item)))
      const res = await GetRequest(urls.getDeliveryMemoData, payloadList[i])
      setCityListData((prevList) => prevList.map((item) => (item.id === id ? { ...item, loaded: 2 } : item)))
      const memoData = res?.Data?.Table || []
      memoDataList.push(...memoData)
    }
    setDeliveryMemoData(memoDataList)
    setTableData(getTableInfo(memoDataList))
    setModal('')
    setIsExpanded(true)
  }

  const getFilter = () => {
    const object = {
      CompanyId: loginData.intCompanyID,
      BranchId: loginData.intBranchID,
      CityId: loginData.intBranchCityID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      UserId: loginData.intUserID,
      Mode: selectedTab + 1,
      IsShowAllLRs: !tillDate && !showAll ? 0 : isShowAllLRs, // 1 if show all pending lrs is checked , 0 if tilldate is selected.
      IsDelivered: 0,
    }
    getDeliveryMemo(object)
  }

  const backToScreenView = () => {
    setIsPdfLoaded(false)
  }

  const headerBody = [
    {
      sourceCity: sourceCity.map((item) => item.sourceCityList).join(', '),
      destinationCity: destinationCity.DestinationCity
    }
  ]
  let dynamicHeaderBody = [{
    sourceCity: sourceCity.map((item) => item.sourceCityList).join(', '),
    destinationCity: destinationCity.DestinationCity
  }]
  const headerStyles = {
    0: { cellWidth: 590, halign: 'left', font: 'Roboto', fontSize: 18 },
    1: { cellWidth: 590, halign: 'left', font: 'Roboto', fontSize: 18 },
  }
  const IsLRSelected = (targetLrNo) => {
    return selectedLrs.some(obj => obj.LRNO === targetLrNo)
  }
  const getPdfTableBody = (id = 0) => {
    let newData = []
    let selTableData = []
    const upData = selectedLrs.map((item) => ({ ...item, PaymentTypeVehicle: item.PaymentType }))
    if (selectedLrs.length > 0 && id === 1) {
      selTableData = upData;
    } else {
      selTableData = tableData;
    }
    if (selectedTab === 0) {
      selTableData.map((item, index) => {
        let isSelected = IsLRSelected(item.LRNO)
        let pTypeVehicle = '';
        let rcvrByNum = ''
        let idProof = ''
        if (isSelected) {
          if (reciverName !== '') {
            rcvrByNum = reciverName
          }
          if (reciverPhone !== '') {
            rcvrByNum = rcvrByNum + '\n' + reciverPhone
          }
          if (selectedRecIdType?.IDProof !== '') {
            idProof = selectedRecIdType?.IDProof
          }
          if (ReIdNumber !== '') {
            idProof = idProof + '\n' + ReIdNumber
          }
        } else {
          pTypeVehicle = item.PaymentType
        }
        newData[index] = {
          srNo: item.srNo,
          LRNO: item.LRNO,
          LRNOManual: item.LRNO + '\n' + item.ManualLRNo,
          PaymentType: item.PaymentType,
          PaymentTypeVehicle: item.PaymentType,
          SourceCity: item.SourceCity,
          SrCityBranch: item.SourceCity + '\n' + item.SourceBranch,
          DestinationCity: item.DestinationCity,
          DstCityBranch: item.DestinationCity + '\n' + item.DestinationBranch,
          Sender:item.Sender,
          sendSender: item.Sender + '\n' + item.SenderMobileNo,
          RecName: item.RecName ,
          RecMobileNo: item.RecMobileNo,
          sendRec: item.RecName + '\n' + item.RecMobileNo,
          rcvDateChallan: item.ReceiptDate + '\n' + item.ChallanNo,
          rcvrByNo: rcvrByNum,
          idProofNo: idProof,
          Units: item.Units,
          TotalDues: item.TotalDues,
          AdditionalDeliveryCartage: item.AdditionalDeliveryCartage,
          HamaliCharges: item.HamaliCharges,
          DeliveryChg: item.DeliveryChg,
          ExtraHamli: item.ExtraHamli,
          DemurrageChg: item.DemurrageChg,
          Discount: item.Discount,
          DeliveryGST: item.DeliveryGST,
          finalAmount: item.finalAmount
        }
      })
    } else if (selectedTab === 1) {
      tableData.map((item, index) => {
        let isSelected = IsLRSelected(item.LRNO)
        newData[index] = {
          srNo: item.srNo,
          LRNOManual: item.LRNO + '\n' + item.ManualLRNo,
          PaymentTypeDate: item.PaymentType + '\n' + item.ReceiptDate,
          DstCityBr: item.DestinationCity + '\n' + item.DestinationBranch,
          SrCityBranch: item.SourceCity + '\n' + item.CurrentBranch,
          Units: item.Units,
          TotalDues: item.TotalDues,
          BranchForDelTrans: isSelected ? brnchForDelivery?.BranchName : '',
          TransByVehicleNo: isSelected ? trnsfrVehicle?.VehicleNo : '',
          DriverName: isSelected ? driverName?.DriverConductorName : '',
          Remarks: isSelected ? remark : '',
        }
      })
    } else if (selectedTab === 2) {
      tableData.map((item, index) => {
        newData[index] = {
          srNo: index + 1,
          LRNOManual: item.LRNO + '\n' + item.ManualLRNo,
          PaymentTypeDate: item.PaymentType + '\n' + item.ReceiptDate,
          DstCityBr: item.DestinationCity + '\n' + item.DestinationBranch,
          SrCityBranch: item.SourceCity + '\n' + item.CurrentBranch,
          Units: item.Units,
          TotalDues: item.TotalDues,
          OtherBranchInchargeName: item.OtherBranchInchargeName,
          OtherBranchIncContactNo: item.OtherBranchIncContactNo,
          VehicleNo: item.VehicleNo,
          DriverNoName: item.DriverName + '\n' + item.DriverContactNo,
        }
      })
    }
    return newData
  }


  const newPdfMethods = {
    getPdfTableBody
  }
  const generateEXEPrintFormat = (pdfTableData, isSave) => {
    try {
      const pdfColumns = columnDefsForExeFormat.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      });
      setIsPdfLoaded(false);

      jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
      jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

      const doc = new jsPDF({
        orientation: 'p',
        format: [1240, 1754],
        unit: 'px',
      });

      doc.autoTableSetDefaults({
        headStyles: { fontSize: 14, FontFace: 'Roboto', width: 'auto', halign: 'left', fillColor: '#BFE1FF' },
      })

      doc.setProperties({
        title: `DeliveryMemo.pdf`,
        subject: 'Delivery Memo',
        author: 'Maven Tech Labs Pvt. Ltd.',
        keywords: 'maven tech, Cargo system, DeliveryMemo',
        creator: 'MTLPL',
      })
      var totalPagesExp = '{total_pages_count_string}'
      const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
        const doc = data.doc
        // Footer
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

        var str = 'Page : ' + doc.internal.getNumberOfPages()
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(16)
        doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
        doc.setFont('Roboto', 'bold')
        doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
        doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
      }
      autoTable(doc, {
        margin: { top: 180, left: 30, right: 30, bottom: 60 },
        startY: 180,
        alternateRowStyles: {
          fillColor: [255, 255, 255],
        },
        theme: 'grid',
        columns: pdfColumns,
        showHead: 'everyPage',
        rowPageBreak: 'avoid',
        styles: {
          cellPadding: { top: 6, right: 6, bottom: 6, left: 6 },
          minCellHeight: 35,
          valign: 'top',
          lineWidth: [1, 0, 1, 0],
          textColor: '#000000'
        },
        headStyles: {
          fontSize: 16,
        },
        body: pdfTableData,
        tableLineWidth: 0.6,
        columnStyles: exeColumnStyles,
        didParseCell: function (data) {
          var rows = data.table.body
          if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
              data.cell.styles.halign = "right";
            } else {
              data.cell.styles.halign = "left";
            }
          }
        },

        didDrawPage: function (data) {
          // ===== COMPANY HEADER =====
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(30).setFont("Roboto", 'bold')

          doc.text(
            loginData.strCompanyName,
            doc.internal.pageSize.width / 2,
            75,
            { align: 'center' }
          )

          // ===== SUB TITLE =====
          doc.setFontSize(22).setFont("Roboto", 'bold')
          doc.text(
            loginData?.strBranchName,
            doc.internal.pageSize.width / 2,
            105,
            { align: 'center' }
          )

          doc.text(
            'Delivery Memo Report',
            doc.internal.pageSize.width / 2,
            145,
            { align: 'center' }
          )
          doc.setFontSize(14)
          doc.setFont('Roboto', 'bold')

          doc.text(
            `Generation Date : ${moment().format('DD-MMM-YYYY hh:mm A')}`,
            30,
            170
          )

          doc.text(
            `Report Date : ${moment().format('DD-MMM-YYYY')}`,
            doc.internal.pageSize.width - 30,
            170,
            { align: 'right' }
          )
          jsPdfHeaderFooter(data, loginData, totalPagesExp);
        }
      })
      doc.setFont('Roboto')
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setIsPdfLoaded(true);
      if (isSave) {
        doc.save(`${tabLabels[selectedTab]} ${new Date().getTime()}.pdf`)
        setTimeout(() => {
          const pdfUrl = doc.output('bloburl')
          document.getElementById('deliveryMemoOutput').data = pdfUrl
          // document.getElementById('deliveryMemoOutput').data = doc.output('datauristring', 'DeliveryMemo.pdf')
          focusElemnt('pdfBack')
        }, 1000)
      } else {
        setTimeout(() => {
          const pdfUrl = doc.output('bloburl')
          document.getElementById('deliveryMemoOutput').data = pdfUrl
          focusElemnt('pdfBack')
        }, 1000)
      }
    } catch (err) {
      console.log(err)
      setIsPdfLoaded(false)
    }
  }
  const generatePdf = (isSave, id) => {
    let pdfColumns = [];
    let pdfTableData = []
    switch (selectedTab) {
      case 0:
        pdfColumns = getCompanyColumnDefsOneA().map((col) => {
          return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        });
        pdfTableData = getPdfTableBody(id);
        break;
      case 1:
        pdfColumns = columnDefsTwoA.map((col) => {
          return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        });
        pdfTableData = getPdfTableBody();
        break;
      case 2:
        pdfColumns = columnDefsThreeA.map((col) => {
          return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        });
        pdfTableData = getPdfTableBody();
        break;
    }
    if (selectedTab === 0 && (loginData?.intCompanyID === SAMAY_TRAVEL || loginData?.intCompanyID === TULSI_TRAVEL)) {
      generateEXEPrintFormat(pdfTableData, isSave)
    } else {
      const pdfHeaderColumns = headerColumnDefs.map((col) => {
        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
      });

      try {
        setIsPdfLoaded(false);

        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

        const doc = new jsPDF({
          orientation: 'p',
          format: [1240, 1754],
          unit: 'px',
        });

        doc.autoTableSetDefaults({
          headStyles: { fontSize: 14, FontFace: 'Roboto', width: 'auto', halign: 'left', fillColor: '#BFE1FF' },
        })

        doc.setProperties({
          title: `DeliveryMemo.pdf`,
          subject: 'Delivery Memo',
          author: 'Maven Tech Labs Pvt. Ltd.',
          keywords: 'maven tech, Cargo system, DeliveryMemo',
          creator: 'MTLPL',
        })
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
          const doc = data.doc
          // Footer
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

          var str = 'Page : ' + doc.internal.getNumberOfPages()
          if (typeof doc.putTotalPages === 'function') {
            str = str + ' of ' + totalPagesExp
          }
          doc.setFontSize(16)
          doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
          doc.setFont('Roboto', 'bold')
          doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
          doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        let totalFilterCols = Object.keys(appliedMoreFilter).length + 2 //add2 for source and destination cities
        let numOfTables = Math.ceil(totalFilterCols / 5)
        if (totalFilterCols === 2) {
          autoTable(doc, {
            margin: { left: 30, right: 30, bottom: 5 },
            startY: 185,
            alternateRowStyles: {
              fillColor: [255, 255, 255],
            },
            theme: 'grid',
            columns: pdfHeaderColumns,
            body: headerBody,
            styles: {
              cellPadding: { top: 6, right: 12, bottom: 6, left: 12 },
              minCellHeight: 35,
              valign: 'middle',
              fontSize: 18,
            },
            headStyles: {
              lineWidth: 1,
              fontSize: 18,
            },
            columnStyles: headerStyles,
            didParseCell: function (data) {
              if (data.row.index === 0) {
                data.cell.styles.textColor = '#000000';
              }
            },
            didDrawPage: function (data) {
              doc.setTextColor(0, 0, 0)
              doc.setFontSize(18)
              doc.setFont("Roboto", 'normal')
              doc.text(`Received Date: ${moment(memoFromDate).format('DD-MMM-YYYY')} To ${moment(memoToDate).format('DD-MMM-YYYY')}`, 30, 170)
              doc.setFontSize(18)
              doc.setFont("Roboto", 'normal')
              doc.text(`Report: ${tabLabels[selectedTab]}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
              jsPdfHeaderFooter(data, loginData, totalPagesExp);
            }
          })
        } else if (totalFilterCols > 2) {
          for (let key in appliedMoreFilter) {
            dynamicHeaderDefs.push({ header: dynamicFilterNames[key], dataKey: key, xlCol: { dataType: 'string', dataFormatter: null } })
            dynamicHeaderBody[0][key] = appliedMoreFilter[key]
          }
          let n = 5;
          let start = 185;
          for (let i = 0; i < numOfTables; i++) {
            const slice = dynamicHeaderDefs.slice(i * n, (i + 1) * n)
            if (slice?.length < 5) {
              let emptyCols = 5 - slice?.length
              for (let i = 0; i < emptyCols; i++) {
                slice.push({ header: '', dataKey: '', xlCol: { dataType: 'string', dataFormatter: null } })
              }
            }
            autoTable(doc, {
              margin: { left: 30, right: 30, bottom: 5 },
              startY: start,
              alternateRowStyles: {
                fillColor: [255, 255, 255],
              },
              theme: 'grid',
              columns: slice,
              body: dynamicHeaderBody,
              headStyles: {
                lineWidth: 1,
                fontSize: 18,
              },
              styles: {
                cellPadding: { top: 6, right: 12, bottom: 6, left: 12 },
                minCellHeight: 35,
                valign: 'middle',
                fontSize: 18,
              },
              columnStyles: dynamicTableStyles,
              didParseCell: function (data) {
                if (data.row.index === 0) {
                  data.cell.styles.textColor = '#000000';
                  data.cell.styles.minCellHeight = 35;
                }
              },
              didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18)
                doc.setFont("Roboto", 'normal')
                doc.text(`Received Date: ${moment(memoFromDate).format('DD-MMM-YYYY')} To ${moment(memoToDate).format('DD-MMM-YYYY')}`, 30, 170)
                doc.setFontSize(18)
                doc.setFont("Roboto", 'bold')
                doc.text(tabLabels[selectedTab], doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
                jsPdfHeaderFooter(data, loginData, totalPagesExp);
              }
            })
            start = doc.lastAutoTable.finalY
          }
        }
        const tableWidth = doc.internal.pageSize.width - 180; // Adjust as needed

        autoTable(doc, {
          margin: { top: 120, left: 30, right: 30, bottom: 60 },
          startY: doc.lastAutoTable.finalY + 24,
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
          theme: 'grid',
          columns: pdfColumns,
          showHead: 'everyPage',
          rowPageBreak: 'avoid',
          styles: {
            cellPadding: { top: 6, right: 6, bottom: 6, left: 6 },
            minCellHeight: 35,
            valign: 'top',
            lineWidth: [1, 0, 1, 0],
            textColor: '#000000'
          },
          headStyles: {
            fontSize: 16,
          },
          body: pdfTableData,
          tableLineWidth: 0.6,
          columnStyles: selectedTab === 2 ? columnStylesThree : selectedTab === 1 ? columnStylesTwo : isCompanyTwelve ? columnStylesOneCompanyTwelve : columnStylesOne,
          didParseCell: function (data) {
            var rows = data.table.body
            if (data.row.section === 'head') {
              if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                data.cell.styles.halign = "right";
              } else {
                data.cell.styles.halign = "left";
              }
            }
          },

          didDrawPage: function (data) {
            doc.setTextColor(40)
            doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
            doc.setFontSize(26).setFont("Roboto", 'bold')
            doc.setTextColor(16, 79, 162)
            doc.text('Cargo System | Delivery Memo', 30 + 60, 80)
            doc.setTextColor(0, 0, 0)
            doc.setFontSize(22).setFont("Roboto", 'normal')
            doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
            jsPdfHeaderFooter(data, loginData, totalPagesExp);
          }
        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp)
        }
        setIsPdfLoaded(true);
        if (isSave) {
          doc.save(`${tabLabels[selectedTab]} ${new Date().getTime()}.pdf`)
          setTimeout(() => {
            const pdfUrl = doc.output('bloburl')
            document.getElementById('deliveryMemoOutput').data = pdfUrl
            // document.getElementById('deliveryMemoOutput').data = doc.output('datauristring', 'DeliveryMemo.pdf')
            focusElemnt('pdfBack')
          }, 1000)
        } else {
          setTimeout(() => {
            const pdfUrl = doc.output('bloburl')
            document.getElementById('deliveryMemoOutput').data = pdfUrl
            // document.getElementById('deliveryMemoOutput').data = doc.output('datauristring', 'DeliveryMemo.pdf')
            focusElemnt('pdfBack')
          }, 1000)
        }
      } catch (err) {
        console.log(err)
        setIsPdfLoaded(false)
      }
    }
  }

  const printClick = (param, id) => {
    if (id === 0) {
      setIsPdfLoaded(false)
      generatePdf(param, id)
    } else if (id === 1 && selectedLrs.length > 0) {
      setIsPdfLoaded(false)
      generatePdf(param, id)
    } else {
      updateAlertError({ show: true, msg: 'Please Select Atleast One LR', nextId: '' })
    }
  }

  const onLrClick = (BookingID) => {
    setClickedBookingID(BookingID)
    if (lrDetailsData.hasOwnProperty(BookingID)) {
      setShowLRDetails(true)
    } else {
      const data = {
        CompanyID: intCompanyID,
        BranchID: intBranchID,
        BookingID,
      }
      getLrDetailsWIthBookingID(data, lrDetailsData)
    }
  }
  useEffect(() => {
    if (lrDetailsData.hasOwnProperty(clickBookingId)) {
      setShowLRDetails(true)
    }
  }, [lrDetailsData])
  const bulkDeliveryData = {
    bulkDeliveryCheck,
    reciverName,
    reciverPhone,
    selectedRecIdType,
    ReIdNumber,
    selectedMOP,
    selectedParty,
    selectedVehicle,
    remarks,
    selectedLrs,
    vehicleList,
    getIdProof,
    // methodOfPayment: methodOfPayment?.Data?.Table || [],
    MOPList,
    partyList,
    loginData,
    appliedMoreFilter,
    memoFromDate,
    memoToDate,
    showMore,
    checkboxStates,
    excelData,
    setexcelData
  }
  const bulkDeliveryDataTwo = {
    appliedMoreFilter,
    tableData,
    loginData,
    memoFromDate,
    memoToDate,
    bulkDeliveryCheck,
    selectedLrs,
    brnchForDelivery,
    trnsfrVehicle,
    driverName,
    remark,
    brnchList,
    driverInfo,
    vehicleList,
    showMore
  }
  const validateTransfer = () => {
    if (selectedLrs?.length < 1) {
      updateAlertError({ show: true, msg: error.SELECT_LR })
    } else if (brnchForDelivery.BranchID === '') {
      updateAlertError({ show: true, msg: error.TRANSFER_TO_BRANCH, nextId: 'memoBrnchForDeliveryTransfer' })
    } else if (trnsfrVehicle.VehicleID === '') {
      updateAlertError({ show: true, msg: error.TRANSFER_BY_VEHICLE, nextId: 'memoTrnsfrByVehicleNo' })
    } if (remark === '') {
      updateAlertError({ show: true, msg: 'Enter Transfer Remark', nextId: 'memoTrnsfrRemark' })
    } else {
      setShowConfirmationTwo(true)
    }
  }
  const validateDelivery = () => {
    if (!Array.isArray(selectedLrs) || selectedLrs?.length === 0) {
      updateAlertError({ show: true, msg: 'Please Select Some Lr for Delivery', nextId: 'memoGenerate' })
    }
    else if (reciverName === '') {
      updateAlertError({ show: true, msg: error.RECIPIENT_NAME, nextId: 'memoDeliveryReceiver' })
    } else if (reciverPhone === '' && HasContactNoCompulsory === 1) {
      updateAlertError({ show: true, msg: error.RECIPIENT_CONTACT, nextId: 'memoDeliveryReceiverPhone' })
    } else if (reciverPhone.length < 10) {
      updateAlertError({ show: true, msg: error.RECIPIENT_CONTACT_LENGTH, nextId: 'memoDeliveryReceiverPhone' })
    }
    // else if (selectedRecIdType.IDProof === '') {
    //   updateAlertError({ show: true, msg: 'Please select the Id Proof Type', nextId: 'memoDeliveryReceiverIdType' })
    // } else if (ReIdNumber === '') {
    //   updateAlertError({ show: true, msg: 'Please Enter the Id Proof Number', nextId: 'memoDeliveryReceiverIdNumber' })
    // } 
    else if (selectedMOP?.ModeName === '') {
      updateAlertError({ show: true, msg: 'Please Select the Mode of Payment', nextId: 'memoDeliveryMop' })
    } else if (selectedVehicle?.VehicleNo === '') {
      updateAlertError({ show: true, msg: 'Please Select the Vehicle No', nextId: 'memoDeliveryVehicle' })
    } else {
      setShowConfirmation(true)
    }
  }
  const bulkDeliveryMehtods = {
    setBulkDeliveryCheck,
    setRecieverName,
    setReceiverPhone,
    setselectedRecIdType,
    setReIdNumber,
    setSelectedMOP,
    setSelectedParty,
    setSelectedVehicle,
    setRemarks,
    setSelectedLrs,
    setTableData,
    bulkDeliver: validateDelivery,
    onLrClick,
    updateSelectedList,
    handleIdProofInput,
    setCheckboxStates,
    updateAlertError
  }
  const bulkDeliverymethodsTwo = {
    bulkDeliverTwo: validateTransfer,
    setSelectedLrs,
    setBrnchForDelivery,
    setTrnsfrVehicle,
    setDriverName,
    setRemark,
    updateSelectedList1
  }
  const confirmationMsg = selectedLrs?.length === 1 ? 'Are you sure you want to Deliver selected LR?' : 'Are You sure you want to bulk Deliver?'
  const ShowBulkDeliveryConfirmation = () => {
    const data = {
      successMessage: confirmationMsg,
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => { bulkDeliver(); setShowConfirmation(false) },
      noAction: () => setShowConfirmation(false)
    }
    return <SuccessPopUp data={data} updateModal={setShowConfirmation} />
  }
  const confirmTrnsfrMsg = selectedLrs?.length === 1 ? 'Are you sure you want to Transfer selected LR?' : 'Are You sure you want to bulk Transfer?'
  const ShowBulkTransferConfirmation = () => {
    const data = {
      successMessage: confirmTrnsfrMsg,
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => { bulkDeliverTwo(); setShowConfirmationTwo(false) },
      noAction: () => setShowConfirmationTwo(false)
    }
    return <SuccessPopUp data={data} updateModal={setShowConfirmationTwo} />
  }
  const ShowLRDetails = () => {
    const chosenData = lrDetailsData?.[clickBookingId]
    const { Table, Table1 } = chosenData
    const consignmntData = [
      {
        slctdCnsgnmntType: { SubType: Table[0].SubType },
        description: Table[0].Description,
        unit: Table[0].Quantity,
        goods_value: Table[0].GoodsValue,
        wt_actual: Table[0].ActualWeight,
        wt_volume: Table[0].Volume,
        wt_charge: Table[0].ChargedWeight,
        rate: Table[0].Rate,
        freight: Table[0].Freight,
        wt_vlm_len: '0',
        wt_vlm_wid: '0',
        wt_vlm_ht: '0',
        unitType: 'MM',
        action: '',
        slctdMethodOfPckgType: { MOPName: Table[0].mop },
      },
    ]
    const priceSectionData = {
      freight: '0',
      coll_cartage: Table1[0].CollCartage,
      del_cartage: Table1[0].DeliveryCartage,
      hamali: Table1[0].HamaliCharges,
      op_hamali: Table1[0].OperatorHamaliChg,
      valuation: Table1[0].Insurance,
      doc_fee: Table1[0].DocumentCharges,
      pickup_fee: Table1[0].PickupCharge,
      dropoff_fee: Table1[0].DropOffCharge,
      gst: Table1[0].gst,
      CCBrkup_pckp: 0,
      CCBrkup_cmsn: 0,
      CCBrkup_rtrn: 0,
      gross_amount: Table1[0].NetAmount,
    }

    const data = {
      headTxt: 'LR Details',
      hideContols: true,
      consignmntData,
      priceSectionData,
      strtCity: { CityName: Table1[0].SourceCity },
      strtBrnch: { BranchName: Table1[0].SourceBranch },
      sendMobNo: Table1[0].SenderMobileNo,
      sendName: Table1[0].Sender,
      senGstnNo: Table1[0].SenderGSTN,
      senCNnST: Table1[0].SenderAddress,
      destCity: { CityName: Table1[0].DestinationCity },
      destBrnch: { BranchName: Table1[0].DestinationBranch },
      recMobNo: Table1[0].RecMobileNo,
      recName: Table1[0].RecName,
      recGstnNo: Table1[0].ReceiverGSTN,
      recCNnST: Table1[0].RecAddress,
      consignerCheck: false,
      consigneeCheck: false,
      selBookingType: { name: Table1[0].PaymentType },
      slctdSndParty: {},
      slctdRcvrParty: {},
      billNo: Table1[0].PartyBillNo,
      billDate: moment(new Date(Table1[0].PartyBillDate)).isValid() ? moment(new Date(Table1[0].PartyBillDate)) : '',
      billAmount: Table1[0].PartyBillAmt,
      ModalData: {
        send: {
          IdProof: false,
          IdProofType: {
            IDProof: false
          },
          IdProofFile: false
        }
      },
      sendMobNo2: Table1[0].SenderAltNo,
      sendMailId: Table1[0].SenderEmailID,
      recMobNo2: Table1[0].RecvAltNo,
      recMailId: Table1[0].ReceiverEmailID,
      pickupAddressObj: {},
      ewayBillNoList: Table1[0].EWayBillNo ? Table1[0].EWayBillNo.split(',') : [],
      CCR: Table1[0].Comments,
      cmnt: Table1[0].Comments,
      deliveryAddressObj: {},
      ewayBillDetailsList: [],
      DefaultCurrencyID
    }
    return <BookingConfirm data={data} updateModal={() => { setShowLRDetails(false); setClickedBookingID(false); }} />
  }
  return (
    <Box className="delivery-memo">
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <StyledTabs
            aria-label="basic tabs example"
            value={selectedTab}
            onChange={handleTabChange}
            sx={{ backgroundColor: '#e5f3fe', height: '49px' }}
            className="delivery-memo-tabs"
          >
            <Tab
              sx={{
                '&.Mui-focusVisible': {
                  border: 0,
                },
              }}
              label={tabLabels[0]}
            />
            <Tab
              sx={{
                '&.Mui-focusVisible': {
                  border: 0,
                },
              }}
              label={tabLabels[1]}
            />
            <Tab
              sx={{
                '&.Mui-focusVisible': {
                  border: 0,
                },
              }}
              label={tabLabels[2]}
            />
          </StyledTabs>
        </Box>
        <Box sx={{ maxHeight: '100%', height: '100%', overflowY: 'scroll' }}>
          <DeliveryMemoFilter
            handleGenerate={handleGenerate}
            getFilter={getFilter}
            setIsShowAllLRs={setIsShowAllLRs}
            deliveryMemoList={deliveryMemoList}
            tableData={deliveryMemoData}
            setTableData={setTableData}
            deliveryMemoData={deliveryMemoData}
            filters={filters}
            setFilterHeight={setFilterHeight}
            memoFilterData={memoFilterData}
            memoFilterMethods={memoFilterMethods}
            getTableInfo={getTableInfo}
          />
          <Stack
            component={Paper}
            direction="row"
            spacing={2}
            sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
            className="booking-confirmation-section"
          >
            <Box sx={{ width: '100%', height: '2px', background: '#ccc', margin: '0' }}></Box>
          </Stack>
          {!isPdfLoaded ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '10px',
                marginTop: '-5px',
                background: '#fff',
                display: isExpanded ? 'block' : 'none',
                height: `calc(100% - ${filterheight}px)`,
              }}
            >
              <Box sx={{ ...sx.itemsx, justifyContent: 'space-between', marginLeft: '5px' }}>
                <Box sx={{ fontWeight: 'bold', color: '#444444' }}>{tabLabels[selectedTab]}</Box>
                <Box sx={{ ...sx.itemsx, alignItems: 'flex-end' }}>
                  <Button
                    id="memoPrintBtn"
                    startIcon={<PrintIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '12px' }}
                    onClick={() => {
                      printClick(false, 0)
                    }}
                    onKeyDown={(e) => navigation1(e, 'memeoShortPrint', showMore ? 'memoNext2' : 'memoToggleFilter')}
                  >
                    Print
                  </Button>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                  />
                  <Button
                    id="memeoShortPrint"
                    startIcon={<PrintShortIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '12px' }}
                    onClick={() => {
                      printClick(false, 1)
                    }}
                    onKeyDown={(e) => navigation1(e, 'memoExcelBtn', 'memoPrintBtn')}
                  >
                    Short Print
                  </Button>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                  />

                  <Grid item xs={6} md={2}>
                    <Button
                      id="memoExcelBtn"
                      startIcon={<ExcelIcon />}
                      variant="contained"
                      color="primary"
                      style={{ ...transparentStyle(theme), fontSize: '12px' }}
                      onClick={(e) => {
                        e.preventDefault()
                        clickElement('xls-button-memo')
                      }}
                      onKeyDown={(e) => navigation1(e, 'memoExportPdfBtn', 'memeoShortPrint')}
                    >
                      EXPORT AS EXCEL
                    </Button>
                    <ReactHtmlTableToExcel
                      id="xls-button-memo"
                      table="delivery-memo-excel-tbl"
                      filename={tabLabels[selectedTab]}
                      sheet="sheet 1"
                      buttonText="EXPORT AS EXCEL"
                      className="excel-button"
                    />
                  </Grid>
                  <Divider
                    orientation="vertical"
                    flexItem
                    style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                  />
                  <Button
                    id="memoExportPdfBtn"
                    startIcon={<PdfIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '12px' }}
                    onClick={(e) => {
                      printClick(true, selectedLrs.length > 0 ? 1 : 0)
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      navigation3(e, selectedTab === 0 || selectedTab === 1 ? 'memoTablerowCheck0' : 'memoFromDate', 'memoExcelBtn', () =>
                        printClick(true)
                      )
                    }}
                  >
                    Export As PDF
                  </Button>
                </Box>
              </Box>
              {selectedTab === 0 && (
                <DeliveryMemoTable
                  tableData={tableData}
                  selectedLRs={selectedLrs}
                  selectedTab={selectedTab}
                  data={bulkDeliveryData}
                  methods={bulkDeliveryMehtods}
                />
              )}
              {selectedTab === 1 && <DeliveryMemoTableTwo data={bulkDeliveryDataTwo} methods={bulkDeliverymethodsTwo} />}
              {selectedTab === 2 && (
                <DeliveryMemoTableThree
                  tableData={tableData}
                  deliveryMemoData={deliveryMemoData}
                  setTableData={setTableData}
                  loginData={loginData}
                  memoFromDate={memoFromDate}
                  memoToDate={memoToDate}
                  moreFilter={moreFilter}
                  appliedMoreFilter={appliedMoreFilter}
                  showMore={showMore}
                />
              )}
              {/* </Box> */}
            </Box>
          ) : (
            <Box style={{ position: 'relative', width: '100%', height: '100%' }}>
              {
                <object
                  id="deliveryMemoOutput"
                  type="application/pdf"
                  width="100%"
                  height="100%"
                  style={{ marginTop: '50px' }}
                  title="MTLPL - Pending Delivery"
                  aria-label="MTLPL - CARGO - Delivery Memo"
                ></object>
              }
              <Button
                id="pdfBack"
                className="btn add-btn"
                variant="contained"
                color="error"
                style={{ position: 'absolute', top: '5px', right: '10px' }}
                onClick={() => {
                  backToScreenView()
                }}
                onKeyDown={(e) => {
                  navigation3(e, 'memoFromDate', 'pdfBack', () => {
                    setIsPdfLoaded(false)
                    focusElemnt('memoGenerate')
                  })
                }}
              >
                BACK
              </Button>
            </Box>
          )}
          <Stack
            component={Paper}
            direction="row"
            spacing={2}
            sx={{ background: '#FFF', boxShadow: 'none', alignItems: 'center' }}
            className="booking-confirmation-section"
          >
            <Box sx={{ width: '100%', height: '2px', background: '#ccc', margin: '0' }}></Box>
          </Stack>
        </Box>
        {isExpanded && selectedTab === 0 && (
          <DeliveryMemoBottom1 data={bulkDeliveryData} methods={bulkDeliveryMehtods} updateAlertError={updateAlertError} />
        )}
        {isExpanded && selectedTab === 1 && <DeliveryMemoBottom2 data={bulkDeliveryDataTwo} methods={bulkDeliverymethodsTwo} />}
        {showConfirmation && <ShowBulkDeliveryConfirmation />}
        {showConfirmationTwo && <ShowBulkTransferConfirmation />}
        {showLRDetails && <ShowLRDetails />}
        {modal === 'loaderModal' && <LoaderModel list={cityListData} />}
      </Box>
    </Box>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateAlertError,
  getDeliveryMemo,
  getDriverList,
  getVehicleList,
  getIDProofList,
  GetMOFPaymentUpdate,
  getLrDetailsWIthBookingID,
  updateLoader
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryMemo)
